import type {Link} from 'typings/portaro.fe.types';
import type {IAugmentedJQuery, IFilterService, IOnInit, IScope, ITranscludeFunction, IWindowService} from 'angular';
import AbstractClassAddingController from '../abstract-class-adding.controller';
import {isPartOfBaseURL} from 'shared/utils/url-utils';

export class LinkComponentController extends AbstractClassAddingController implements IOnInit {
    public link: Link;
    public content: string;
    private location: Location;

    /*@ngInject*/
    constructor(private $transclude: ITranscludeFunction, private $filter: IFilterService, $window: IWindowService, $element: IAugmentedJQuery, $scope: IScope) {
        super($element, $scope);
        this.location = $window.location;
    }

    public resolveTarget(): '_self' | '_blank' {
        if (isPartOfBaseURL(this.link.url)) {
            return '_self';
        }
        return '_blank';
    }

    public resolveHref(): string {
        if (this.link.originParameterName) {
            const paramDelimiter = this.link.url.includes('?') ? '&' : '?';

            return `${this.link.url + paramDelimiter + this.link.originParameterName}=${encodeURIComponent(this.location.href)}`;
        }

        return this.link.url;
    }

    public $onInit(): void {
        super.$onInit();
        this.$transclude((clone?: JQLite) => {
            this.content = this.$filter('loc')(this.link);

            if (clone && clone.text) {
                this.content += clone.text();
            }
        });
    }
}

/**
 * @ngdoc component
 * @module portaro.components
 * @name kpLink
 *
 * @requires $transclude
 * @requires $filter
 * @requires $window
 * @requires $element
 * @requires $scope
 * @requires filter:loc
 *
 * @param {Link} link Link definition.
 * @param class Standard class attribute. Classes is transcluded into `a` element and watched for adding by {@link controller:AbstractClassAddingController}.
 *
 * @description
 * Component creates a link with `target` depending on URL base.
 * If URL starts with current location base (protocol+hostname+port), then `target` is `_self` otherwise `target` is `_blank` (new tab/window).
 * Component allows **transclude** custom content after link text.
 */
// eslint-disable-next-line
export default class LinkComponent {
    public static componentName = 'kpLink';

    public template = '<a target="{{$ctrl.resolveTarget()}}" ng-class="$ctrl.classes" ng-href="{{$ctrl.resolveHref()}}">{{$ctrl.content}}</a>';
    public bindings = {
        link: '<'
    };

    public controller = LinkComponentController;
    public transclude = true;
}
